module.exports = __webpack_public_path__ + "img/ALC500-1.888b575f.jpg";